<template>
  <div
    class="annex-preview"
    id="container"
  >
    <iframe
      v-if="showPdf"
      id='previewPdf'
      :src="'/pdf/web/viewer.html?file=' + fileUrl"
      height="760"
      width="100%"
    >
    </iframe>
  </div>
</template>

<script>
let container;
export default {
  name: 'AnnexPreview',
  data() {
    return {
      fileUrl: '',
      showPdf: false,
    };
  },
  activated() {
    if (!this.$route.query.fileUrl) {
      return;
    }
    const { fileUrl } = this.$route.query;
    const baseUrl = '';
    // if (process.env.NODE_ENV === 'production') {
    //   baseUrl = 'http://192.168.4.130:8888';
    // }
    this.fileUrl = `${baseUrl}/group1/${fileUrl}`;
    console.log(this.fileUrl);
    this.$nextTick(() => {
      this.showPdf = true;
    });
  },
  methods: {
    // async getPDF(url) {
    //   // const pdf = await PDFJS.getDocument(url);
    //   // container = container || document.querySelector('#container');
    //   // for (let i = 0; i < pdf.numPages; i++) {
    //   //   try {
    //   //     await this.rendPDF(pdf, i);
    //   //   } catch (e) {
    //   //     // console.error(e)
    //   //   }
    //   // }
    // },
    async rendPDF(pdf, num) {
      const page = await pdf.getPage(num);
      // 设置展示比例
      const scale = 1.5;
      const viewport = page.getViewport(scale);

      const pageDiv = document.createElement('div');
      pageDiv.setAttribute('id', `page-${page.pageIndex + 1}`);
      pageDiv.setAttribute('style', 'position: relative');
      container.appendChild(pageDiv);

      const canvas = document.createElement('canvas');
      pageDiv.appendChild(canvas);
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport,
      };

      await page.render(renderContext);
      // debugger
      // const textContent = await page.getTextContent();
      // 创建文本图层div
      const textLayerDiv = document.createElement('div');
      textLayerDiv.setAttribute('class', 'textLayer');
      textLayerDiv.setAttribute('style', `width: ${viewport.width}px; margin: 0 auto;`);
      // 将文本图层div添加至每页pdf的div中
      pageDiv.appendChild(textLayerDiv);

      // 创建新的TextLayerBuilder实例
      // const textLayer = new TextLayerBuilder({
      //   textLayerDiv,
      //   pageIndex: page.pageIndex,
      //   viewport,
      // });

      // textLayer.setTextContent(textContent);

      // textLayer.render();
    },
  },
};
</script>

<style>
</style>
